import { render, staticRenderFns } from "./media-planning-xv-order-app.vue?vue&type=template&id=4b33e016"
import script from "./media-planning-xv-order-app.vue?vue&type=script&lang=js"
export * from "./media-planning-xv-order-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports